import SubmissionError from '../error/SubmissionError';
import { API_HOST, API_PATH } from '../config/_entrypoint';
import auth from '../store/modules/auth';
const jsonLdMimeType = 'application/ld+json';
import router from '../main';
export default function (url, options = {}) {
  if ('undefined' === typeof options.headers) options.headers = new Headers();
  if (null === options.headers.get('Accept')) options.headers.set('Accept', jsonLdMimeType);

  if ('undefined' !== options.body && !(options.body instanceof FormData) && null === options.headers.get('Content-Type')) {
    options.headers.set('Content-Type', jsonLdMimeType);
  }
  let authheader=auth.getAuthHeader();

  if (authheader.Authorization) options.headers.set('Authorization',authheader.Authorization);


  const link = url.includes(API_PATH) ? API_HOST + url : API_HOST + API_PATH + url;

  return fetch(link, options).then(response => {
    if (response.ok) return response;

    return response
      .json()
      .then(json => {
            if (json && json.code && json.code==401) {
                localStorage.setItem('previousRoute', vue.$route.path);
                vue.$router.push('/login');
            }

        const error = json['hydra:description'] ? json['hydra:description'] : response.statusText;
        if (!json.violations) throw Error(error);

        let errors = {_error: error};
        json.violations.map((violation) => errors[violation.propertyPath] = violation.message);


        throw new SubmissionError(errors);
      });
  });
}



// WEBPACK FOOTER //
// ./src/utils/fetch.js